import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MessagingService } from '../../services/messaging.service';
import { AsyncPipe } from '@angular/common';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush, // OBS! OnPush
    selector: 'app-messaging',
    templateUrl: './messaging.component.html',
    styleUrls: ['./messaging.component.scss'],
    imports: [AsyncPipe]
})
export class MessagingComponent implements OnInit, OnDestroy {

    public successMsg = new BehaviorSubject<string>(null);
    public warningMsg = new BehaviorSubject<string>(null);
    public errorMsg = new BehaviorSubject<string>(null);
    
    private messageTimeoutMilliSeconds = 5000;
    private successSubscription: Subscription;
    private warningSubscription: Subscription;
    private errorSubscription: Subscription;

    constructor(
        private messaging: MessagingService
    ) { }

    // Sätter en timeout på alla meddelande som visas, så att de tas bort efter messageTimeoutMilliSeconds
    public ngOnInit(): void {
        // Koppla upp mot messageService och lyssna efter meddelanden
        this.successSubscription = this.messaging.successObservable.subscribe((message: string) => {
            this.showSuccessMsg(message);
            setTimeout(() => {
                this.showSuccessMsg(null); // Ta bort meddelandet igen.
            }, this.messageTimeoutMilliSeconds);
        });
        this.warningSubscription = this.messaging.warningObservable.subscribe((message: string) => {
            this.showWarningMsg(message);
            setTimeout(() => {
                this.showWarningMsg(null); // Ta bort meddelandet igen.
            }, this.messageTimeoutMilliSeconds);
        });
        this.errorSubscription = this.messaging.errorObservable.subscribe((message: string) => {
            this.showErrorMsg(message);
            setTimeout(() => {
                this.showErrorMsg(null); // Ta bort meddelandet igen.
            }, this.messageTimeoutMilliSeconds);
        });
    }

    public ngOnDestroy(): void {
        if (this.successSubscription)
            this.successSubscription.unsubscribe();
        if (this.warningSubscription)
            this.warningSubscription.unsubscribe();
        if (this.errorSubscription)
            this.errorSubscription.unsubscribe();
    }

    /**
     * Visar grönt rätt-meddelande
     * @param message
     */
    private showSuccessMsg(message: string) {
        this.successMsg.next(message);
    }

    /**
     * Visar orange varnings-meddelande
     * @param message
     */
    private showWarningMsg(message: string) {
        this.warningMsg.next(message);
    }

    /**
     * Visar rött fel-meddelande
     * @param message
     */
    private showErrorMsg(message: string) {
        this.errorMsg.next(message);
    }
}
